import React from 'react';

export const NotFound = () => {
  return (
    <div>
      <h1>ERROR 404</h1>
      <p>THe component you are looking is not found...</p>
    </div>
  );
};

export default NotFound;
